import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  paper: {
    width: '100%',
    maxWidth: 800,
    [theme.breakpoints.down('md')]: {
      '&&.MuiDialog-paper': {
        margin: '1rem',
        width: 'calc(100vw - 2rem)',
        maxWidth: 'calc(100vw - 2rem)',
        height: 'calc(100dvh - 2rem)',
        maxHeight: 'calc(100dvh - 2rem)',
        overflow: 'hidden',
      },
      '& > *': {
        height: '100%',
        maxHeight: '100%',
      },
    },
  },
  wrapper: {
    padding: theme.spacing(10),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      padding: theme.legacySpacing(4, 6, 6, 6),
      gap: 0,
      height: '100%',
      minHeight: 0,
      boxSizing: 'border-box',
      '& > :last-child': {
        flex: 1,
        minHeight: 0,
      },
    },
  },
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      width: '100%',
      paddingBottom: theme.spacing(4),
      margin: theme.legacySpacing(1, 0, 4, 0),
      borderBottom: `thin solid ${theme.palette.grey[400]}`,
      flexShrink: 0,
    },
  },
  title: {
    fontWeight: 900,
    flexGrow: 1,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
      fontSize: 18,
      margin: 0,
    },
  },
  closeButton: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(-1, -1, 0, 0),
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(-1, -2, 0, 0),
    },
  },
}));

export default useStyles;
